import React from 'react';
import styles from '../styles/cards.module.scss';
import { ReactComponent as Visa } from '@ui-kit/images/visa.svg';
import { ReactComponent as Mastercard } from '@ui-kit/images/mastercard.svg';

export default function Cards() {
  return (
    <div className={styles.cards}>
      <Visa />
      <Mastercard />
    </div>
  );
}
